<template>
  <div class="add-tag">
    <Tag :color="color" closable v-for="(text, i) in tagList" :key="i" @on-close="del(i)">{{ text }}</Tag>
    <Input
      type="text"
      v-model.trim="text"
      :maxlength="maxlength"
      :show-word-limit="true"
      :placeholder="placeholder"
      v-show="tagList.length < size"
      @on-enter="add"
      key="4"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default() {
        return [];
      }
    },
    maxlength: {
      default: 5
    },
    size: {
      default: 3
    },
    placeholder: {
      default: '输入标签名称并回车新增标签'
    },
    color: {
      default: 'blue',
      type: String
    }
  },
  data() {
    return {
      tagList: [],
      text: ''
    };
  },
  watch: {
    value: {
      handler(newVal) {
        console.log(newVal);
        if (newVal) {
          this.tagList = newVal;
        } else {
          this.tagList = [];
        }
      }
    },
    immediate: true
  },
  methods: {
    add() {
      if (this.text) {
        this.tagList.push(this.text);
        this.text = '';
        this.$emit('input', this.tagList);
      } else {
        this.$notice.msg('请输入标签');
      }
    },
    del(i) {
      this.tagList.splice(i, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.add-tag /deep/ {
  .ivu-icon-ios-close {
    color: #333 !important;
  }
}
</style>
